import { useTokenListByChain } from "hooks/useTokenListByChain";
import { useMemo } from "react";
import { GlobalStore } from "store/global/GlobalStore";
import { Token } from "store/global/TokenEnum";
import { getSelectedTokenSymbolArray } from "utils/quoteUtils";
import { getTokenRowDisabledReason } from "utils/tokenSelectorUtils";
import { CounterParty } from "utils/tradeUtils";

export const useGetTokenRowDisabledReason = () => {
  const tokenList = useTokenListByChain();
  const chain = GlobalStore.useState(s => s.network);
  const takerTokens = GlobalStore.useState(s => s.takerTokens);
  const makerTokens = GlobalStore.useState(s => s.makerTokens);
  const takerTokensArray = useMemo(() => getSelectedTokenSymbolArray(takerTokens), [takerTokens]);
  const makerTokensArray = useMemo(() => getSelectedTokenSymbolArray(makerTokens), [makerTokens]);

  return (symbol: Token, counterParty: CounterParty, isChangingToken: undefined | Token) => {
    return getTokenRowDisabledReason(
      symbol,
      chain,
      counterParty,
      takerTokensArray,
      makerTokensArray,
      tokenList,
      isChangingToken
    );
  };
};
